import CurrentUA from '@ali/tbm-ua';
import Url from '@ali/tbm-url';
import { froms, DEFAULT_CHANNEL } from './froms';
import { getFromName } from './getFromName';
import { From } from './types';

export function getFrom(UA = CurrentUA) {
  const isDamaiDomain = window?.location?.hostname?.indexOf('damai.cn') !== -1;
  const urlQuery = Url().query;
  const from = froms[getFromName(UA)] || froms.def;
  const channelArr = from?.comboChannel || [];
  const output: From = {
    name: from.name,
    platform: UA.isIOS
      ? from.platform[0]
      : UA.isOpenHarmony
        ? from.platform[2] || from.platform[1]
        : from.platform[1],
    comboChannel: isDamaiDomain
      ? channelArr[1] || DEFAULT_CHANNEL.comboChannel[1]
      : channelArr[0] || DEFAULT_CHANNEL.comboChannel[0],
  };

  /**
   * `bizpass_platform`传参注入的platform值，方便开发环节覆盖platform值
   */
  if (+urlQuery.bizpass_platform > 0) {
    output.platform = urlQuery.bizpass_platform;
  }

  return output;
}
